import React, { useEffect, useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import ImageGallery from 'react-image-gallery';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGallery } from '../../../../redux/action/homePage/gallery/gallery';
import default_image_url from '../../../../redux/api/API';
import MainLoading from '../../../../utils/MainLoading';
import { Link } from 'react-router-dom';
import HomeLightMainTitle from '../../../homeTitle/HomeLightMainTitle';
import { useTranslation } from 'react-i18next';
import './style.scss'

const Gallery = () => {
    const [images, setImages] = useState([])
    const dispatch = useDispatch()
    const gallery = useSelector(state => state.gallery)
    const lang = localStorage.getItem('lang')
    const {t} = useTranslation();

    useEffect(() => {
        if(!gallery.gallery.length) {
            dispatch(fetchGallery())
        }
    }, [])

    useEffect(() => {
        setImages(gallery.gallery.map(item => (
            {
                original: default_image_url+item.large_path,
                thumbnail: default_image_url+item.small_path,
                description : item.name
            }
        )))
    }, [gallery.loading])

    return (
        <>
        {gallery.loading ?
            <MainLoading />
        :
            gallery.gallery.length ?
                <div className='homepage-gallery pt-4'>
                    <Container>
                        <HomeLightMainTitle>{t("pictures gallery")}</HomeLightMainTitle>
                        <Row className='gallery-container'>
                            <div className='galleryinfo col-lg-4'>
                                <h5>
                                    {t("A collection of virtual exhibition images")}
                                </h5>
                                <p>{t("To participate in the virtual exhibition and register your booth by entering the product and booth information, enter through the following link")}</p>
                                <div className='gallery-link'>
                                    <Link to="/register" className='btn text-light btn-outline-primary px-5'>{t("Participate_expo")}</Link>
                                </div>
                            </div>
                            <div className='homepage-gallery-container pt-5 pb-2 col-lg-6 offset-lg-2 col-12'>
                                <ImageGallery items={images} showPlayButton={false} isRTL={lang === 'en' ? false : true} />
                            </div>
                        </Row>
                    </Container>
                </div>
            :
                ''
        }
        </>
    )
}

export default Gallery
